function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#999",
  d: "M9 13.067c-2.318 0-4.2-1.892-4.2-4.223 0-2.33 1.882-4.222 4.2-4.222 2.318 0 4.2 1.892 4.2 4.222 0 2.331-1.882 4.223-4.2 4.223zm6.72-10.978h-2.663L12.016.949A1.668 1.668 0 0 0 10.78.4H7.219a1.7 1.7 0 0 0-1.243.549l-1.033 1.14H2.28c-.924 0-1.68.76-1.68 1.689V13.91A1.69 1.69 0 0 0 2.28 15.6h13.44c.924 0 1.68-.76 1.68-1.689V3.778a1.69 1.69 0 0 0-1.68-1.69z"
})));

var SvgImgAdd = function SvgImgAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgImgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imgAdd.d201d84b.svg";
export { ForwardRef as ReactComponent };